import React, { useEffect, useState } from "react";
import { Field } from "formik";
import { isEmpty } from "lodash";
import { useRequest } from "../../../abstracts";
import {
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  usDateFormat,
  yesNoOptions,
  clearFieldValues,
  SOURCE_CATEGORY_NAME_MAPPING,
} from "../../../utils";
import {
  FieldInput,
  FieldButtonGroup,
  FieldDropSide,
  DatePicker,
  FieldInputDollar,
} from "../../../components";
import { GetMasterSourceNames } from "../../../services";
import SourceDropdown from "../../../components/SourceNameDropDown/SourceNameDropDown";

const EmployerForm = (props) => {
  const {
    fields,
    setErrors,
    setValues,
    values,
    isEdit,
    isSave,
    setFieldValue,
    setFieldError,
    handleChange,
    planId,
    companyId,
    deleteAdditionalAlloc,
  } = props;

  const payload = {
    companyId: companyId || 0,
    sourceType: values[fields.sourceType] || 0,
    sourceCategory: values[fields.sourceCategory] || 0,
    subCategory: values[fields.sourceSubCategory] || 0,
    subSubCategory: values[fields.sourceSubSubCategory] || 0,
  };

  const onDaySelected = (fieldName, value) => {
    setFieldValue(fieldName, value);
  };

  const { response: dropdownList, loading } = useRequest({
    method: GetMasterSourceNames,
    payload,
  });

  const [sourceNameDropDown, setSourceNameDropDown] = useState([]);
  useEffect(() => {
    if (!isEmpty(dropdownList)) {
      setSourceNameDropDown(
        dropdownList.map((option) => ({
          // value: option.name,
          label: option,
        }))
      );
    } else {
      setSourceNameDropDown([]);
    }
  }, [dropdownList]);

  const handleAdiApplicableToSelect = (value) => {
    deleteAdditionalAlloc();
    setValues({
      ...clearFieldValues({
        values,
        fieldsToExculde: [
          fields.sourceType,
          fields.recordKeepingNumber,
          fields.isEarlyRetirement,
        ],
        fieldsToClear: [fields.sourceName],
      }),
      [fields.sourceCategory]: value,
      [fields.isNewContributionAllowed]: false,
      [fields.isSafeHarbourMatch]: false,
      [fields.safeHarbourType]: 1,
      [fields.isDisplayToParticipantWebsite]: false,
      [fields.responsibleMode]: 1,
      [fields.qmacType]: 1,
      [fields.isMaximumLimitApplicable]: false,
      [fields.maximumDollarLimit]: null,
      [fields.isNonPayPeriodApplicable]: false,
      [fields.isIncludeDefferals]: false,
      [fields.isIncludePlanCompensation]: false,
      [fields.isLastDayRule]: false,
      [fields.isHoursRequirement]: false,
      [fields.hours]: null,
      [fields.isNormalRetirement]: false,
      [fields.isEarlyRetirement]: false,
      [fields.isDeath]: false,
      [fields.isDisability]: false,
    });
    setErrors({});
  };
  const handleSourceSubCategoryChange = (value) => {
    deleteAdditionalAlloc();
    setValues({
      ...clearFieldValues({
        values,
        fieldsToExculde: [
          fields.sourceType,
          fields.sourceCategory,
          fields.recordKeepingNumber,
        ],
        fieldsToClear: [fields.sourceName],
      }),
      [fields.sourceSubCategory]: value,
      [fields.isNewContributionAllowed]: false,
      [fields.isSafeHarbourMatch]: false,
      [fields.safeHarbourType]: 1,
      [fields.isDisplayToParticipantWebsite]: false,
      [fields.responsibleMode]: 1,
      [fields.qmacType]: 1,
      [fields.isMaximumLimitApplicable]: false,
      [fields.maximumDollarLimit]: null,
    });
    setErrors({});
  };
  const isAdiApplicableToOther =
    values[fields.sourceCategory] &&
    parseInt(values[fields.sourceCategory], 10) ===
      SOURCE_CATEGORY_NAME_MAPPING.EmployerOther;
  const isAdiApplicableToMatchRoth =
    values[fields.sourceCategory] &&
    parseInt(values[fields.sourceCategory], 10) ===
      SOURCE_CATEGORY_NAME_MAPPING.MatchRoth;
  const isAdiApplicableToNonElectiveRoth =
    values[fields.sourceCategory] &&
    parseInt(values[fields.sourceCategory], 10) ===
      SOURCE_CATEGORY_NAME_MAPPING.NonElectiveRoth;
  return (
    <div>
      <Field
        isRequired
        name={fields.sourceCategory}
        label="Source Category"
        options={toOptionValuesFromMapper(
          OPTIONS_DATA_MAPPER.SOURCES_EMPLOYER_CATERGORIES
        )}
        selectedValue={values[fields.sourceCategory]}
        onChange={handleAdiApplicableToSelect}
        disabled={isEdit || isSave}
        component={FieldButtonGroup}
        size="lg"
      />
      {isAdiApplicableToOther === true && (
        <Field
          isRequired
          name={fields.sourceSubCategory}
          label="Source Sub Category"
          options={toOptionValuesFromMapper(
            OPTIONS_DATA_MAPPER.SOURCES_FORM_EMPLOYER_OTHER_SUB_CATEGORIES
          )}
          selectedValue={values[fields.sourceSubCategory]}
          onChange={handleSourceSubCategoryChange}
          disabled={isEdit || isSave}
          component={FieldButtonGroup}
          size="md"
        />
      )}
      {/* <Field
        isRequired
        name={fields.sourceName}
        label="Source Name"
        type="text"
        autoComplete="off"
        value={values[fields.sourceName]}
        onChange={handleChange}
        disabled={isEdit}
        component={FieldInput}
        noLabelTransform
      /> */}
      <Field
        isRequired
        name={fields.sourceName}
        label="Source Name"
        type="text"
        autoComplete="off"
        value={values[fields.sourceName]}
        disabled={isEdit || values.sourceSubCategory === 11}
        popupContent={
          <SourceDropdown
            data={sourceNameDropDown ? sourceNameDropDown : []}
            setData={setSourceNameDropDown}
            onSelect={(value, name) => {
              setFieldValue(fields.sourceName, name);
            }}
            setFieldValueOuter={setFieldValue}
            value={values[fields.sourceName]}
            payLoad={payload}
          />
        }
        component={FieldDropSide}
        noLabelTransform
      />
      {/* <Field
        isRequired
        name={fields.recordKeepingNumber}
        label="Source ID"
        type="text"
        autoComplete="off"
        value={values[fields.recordKeepingNumber]}
        onChange={handleChange}
        disabled={isEdit}
        component={FieldInput}
        noLabelTransform
        size="sm"
      /> */}

      <Field
        isRequired
        label="Effective start date"
        name={fields.effectiveStartDate}
        value={usDateFormat(values[fields.effectiveStartDate])}
        isDatePicker
        onClear={() => setFieldValue(fields.effectiveStartDate, null)}
        popupContent={
          <DatePicker
            onDayClick={(value) =>
              onDaySelected(fields.effectiveStartDate, value)
            }
            value={usDateFormat(values[fields.effectiveStartDate])}
            minDate={
              (isAdiApplicableToNonElectiveRoth ||
                isAdiApplicableToMatchRoth) &&
              new Date("01-01-2023")
            }
          />
        }
        disabled={isEdit && !isSave}
        component={FieldDropSide}
      />
      <Field
        label="Effective End date"
        name={fields.effectiveEndDate}
        value={usDateFormat(values[fields.effectiveEndDate])}
        isDatePicker
        onClear={() => setFieldValue(fields.effectiveEndDate, null)}
        popupContent={
          <DatePicker
            onDayClick={(value) =>
              onDaySelected(fields.effectiveEndDate, value)
            }
            value={usDateFormat(values[fields.effectiveEndDate])}
            minDate={
              (isAdiApplicableToNonElectiveRoth ||
                isAdiApplicableToMatchRoth) &&
              new Date("01-01-2023")
            }
          />
        }
        disabled={isEdit && !isSave}
        component={FieldDropSide}
      />
      <Field
        isRequired
        name={fields.isNewContributionAllowed}
        label="New Contribution Allowed?"
        options={yesNoOptions}
        selectedValue={values[fields.isNewContributionAllowed]}
        onChange={(value) => {
          setFieldValue(fields.isNewContributionAllowed, value);
        }}
        disabled={isEdit && !isSave}
        component={FieldButtonGroup}
        size="sm"
      />
      <Field
        isRequired
        name={fields.isDisplayToParticipantWebsite}
        label="Display source to employee?"
        options={yesNoOptions}
        selectedValue={values[fields.isDisplayToParticipantWebsite]}
        onChange={(value) => {
          setFieldValue(fields.isDisplayToParticipantWebsite, value);
        }}
        disabled={isEdit && !isSave}
        component={FieldButtonGroup}
        size="sm"
      />

      {values[fields.sourceCategory] == 9 ||
        values[fields.sourceCategory] == 10 || (
          <Field
            isRequired
            name={fields.isSafeHarbourMatch}
            label="Is it a Safe Harbor Source?"
            options={yesNoOptions}
            selectedValue={values[fields.isSafeHarbourMatch]}
            onChange={(value) => {
              setFieldValue(fields.isSafeHarbourMatch, value);
              setFieldValue(fields.isCatchApplicable, value);
              setFieldValue(fields.safeHarbourType, 1);
              //setFieldValue(fields.employerContributionType,null);
              (values[fields.sourceCategory] == 6 ||
                values[fields.sourceCategory] == 7) &&
                setFieldValue(fields.employerContributionType, null);
            }}
            disabled={isEdit && !isSave}
            component={FieldButtonGroup}
            size="sm"
          />
        )}
      <Field
        isRequired
        name={fields.isMaximumLimitApplicable}
        label="Is a maximum limit applicable?"
        options={yesNoOptions}
        selectedValue={values[fields.isMaximumLimitApplicable]}
        onChange={(value) => {
          setFieldValue(fields.isMaximumLimitApplicable, value);
          setFieldValue(fields.maximumDollarLimit, null);
        }}
        disabled={isEdit && !isSave}
        component={FieldButtonGroup}
        size="sm"
      />
      {values[fields.isMaximumLimitApplicable] === true && (
        <Field
          isRequired
          name={fields.maximumDollarLimit}
          label="Maximum Dollar Limit"
          type="number"
          autoComplete="off"
          preventNegative
          min={0}
          max={9999999.99}
          value={values[fields.maximumDollarLimit]}
          onChange={handleChange}
          disabled={isEdit && !isSave}
          component={FieldInputDollar}
        />
      )}
    </div>
  );
};

export default EmployerForm;
